﻿/* eslint-disable max-len */
/* eslint-disable class-methods-use-this */
import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import { fetchRequest } from '@tk/utilities/tk.fetch';
import render from '@tk/utilities/tk.render';
import { isOutsideShapes } from '@tk/utilities/tk.shape.detector';

interface FocusHistoryItem {
    element: HTMLElement;
    index: number;
}

interface KeybindItem {
    keybind: string;
    action: () => void;
}

export default class TKQuickOrder extends TKCustomElementFactory {
    url?: string;
    fieldElement?: HTMLInputElement;
    resetButton?: HTMLButtonElement;
    submitButton?: HTMLButtonElement;
    resultElement?: HTMLElement;
    backButton?: HTMLButtonElement;
    activeClassName: string;
    hasDataClassName: string;
    loadingClassName: string;
    chooseKeybind: string;
    navigateUpKeybind: string;
    navigateDownKeybind: string;
    chooseQuantityKeybind: string;
    closeKeybind: string;
    timerId?: number;
    focusHistory: FocusHistoryItem[] = [];
    keybinds: KeybindItem[];
    allowedToClickBasketButton = true;
    activateBasketButton = false;

    constructor() {
        super();

        this.url = this.getAttribute('data-tk-url') || undefined;
        this.fieldElement = this.querySelector('input') || undefined;
        this.resetButton = this.querySelector<HTMLButtonElement>('[data-tk-quick-order-reset]') || undefined;
        this.submitButton = this.querySelector<HTMLButtonElement>('[data-tk-quick-order-submit]') || undefined;
        this.resultElement = this.querySelector('[data-tk-quick-order-result]') || undefined;
        this.backButton = this.querySelector<HTMLButtonElement>('[data-tk-quick-order-back]') || undefined;
        this.activeClassName = this.getAttribute('data-tk-active-class-name') || 'tk-search--active';
        this.hasDataClassName = this.getAttribute('data-tk-has-data-class-name') || 'tk-search--has-data';
        this.loadingClassName = this.getAttribute('data-tk-loading-class-name') || 'tk-search--loading';
        this.chooseKeybind = this.getAttribute('data-tk-choose-keybind') || 'Enter';
        this.navigateUpKeybind = this.getAttribute('data-tk-navigate-up-keybind') || 'ArrowUp';
        this.navigateDownKeybind = this.getAttribute('data-tk-navigate-down-keybind') || 'ArrowDown';
        this.chooseQuantityKeybind = this.getAttribute('data-tk-choose-quantity-keybind') || 'Enter';
        this.closeKeybind = this.getAttribute('data-tk-close-keybind') || 'Escape';
        this.keybinds = [
            { keybind: this.closeKeybind, action: () => this.hideDropdown() },
        ];
    }

    connectedCallback(): void {
        if (
            !this.url
            || !this.fieldElement
            || !this.resetButton
            || !this.submitButton
            || !this.resultElement
            || !this.backButton
        ) throw new Error('TKQuickOrder: Elements are missing!');

        this.registerInputListener();
        this.registerKeydownListener();
        this.registerSubmitListener();
    }

    registerInputListener() {
        const onInput = this.search.bind(this);
        this.pushListener({ event: 'input', element: this.fieldElement!, action: onInput });
    }

    registerKeydownListener() {
        this.pushListener({ event: 'keydown', element: this, action: this.handleKeydown.bind(this) });
    }

    registerSubmitListener() {
        this.pushListener({ event: 'submit', element: this, action: this.handleSubmit.bind(this) });
    }

    handleKeydown(event: KeyboardEvent) {
        if (event.key === 'Enter') {
            event.preventDefault();

            if (event.target.parentElement.classList.contains('tk-search__input')) {
                // Focus bzw. Select in das  Quantity Feld setzen
                const qty = this.resultElement?.querySelector('.tk-article #input_dim1') as HTMLInputElement || undefined;
                if (qty) {
                    qty.select();
                }
            }

            if (event.target.closest('input') && event.target.closest('input').id === 'input_dim1') {
                // focus auf den WK Button setzen
                const btn = this.resultElement?.querySelector('.tk-article button[type="submit"]') as HTMLButtonElement || undefined;
                if (btn) {
                    btn.focus();
                }
            }

            if (event.target.closest('.tk-article button[type="submit"]')) {
                // WK Button klicken und Focus ins Suchfeld setzen
                const searchField = this.querySelector('input[type="search"]') as HTMLInputElement || undefined;
                const btn = event.target.closest('.tk-article button[type="submit"]') as HTMLButtonElement;
                btn.focus();
                btn.click();
                if (searchField) {
                    searchField.value = '';
                    searchField.focus();
                }
                this.classList.remove('tk-search--has-data');
            }
        }
    }

    handleSubmit(event: SubmitEvent) {
        event.preventDefault();
    }

    showDropdown() {
        this.classList.add(this.activeClassName);
    }

    hideDropdown() {
        this.classList.remove(this.activeClassName);
    }

    search() {
        const { value } = this.fieldElement!;
        if (value.length < 3) {
            this.classList.remove(this.hasDataClassName);
            this.timerId && clearTimeout(this.timerId);
            return;
        }
        this.classList.add(this.loadingClassName);
        this.timerId && clearTimeout(this.timerId);
        this.timerId = setTimeout(() => {
            const data = {
                value,
            };

            fetchRequest({
                requestURL: this.url!,
                resolveHandler: this.renderResult.bind(this),
                payload: data,
            });
        }, 500);
    }

    renderResult(response: TKResponse) {
        if (!response || !response.success) return;
        this.classList.remove(this.loadingClassName);
        const html = render(response.dataAsHtml);
        this.resultElement!.innerHTML = '';
        this.resultElement!.insertAdjacentHTML('afterbegin', html.innerHTML);
        html.childElementCount > 0 && this.classList.add(this.hasDataClassName);
    }
}